/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull browser-ampli'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 139
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/blinq-hq/Blinq/implementation/browser-ampli)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'unnamedenvironment';

export const ApiKey: Record<Environment, string> = {
  unnamedenvironment: ''
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '139',
    branch: 'main',
    source: 'browser-ampli',
    versionId: '74cf4838-0589-4eda-aaf9-f591140cb2f1'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  "[Experiment] home-card-qr-codesize"?: any;
  anonymousId?: any;
  /**
   * Sent from card service, the card being viewed
   */
  card_id?: string;
  /**
   * Sent by the card service, the User ID of the owner of the card being viewed.
   */
  card_owner_user_id?: string;
  createdAt?: any;
  email?: any;
  firstName?: any;
  initial_referrer?: any;
  lastName?: any;
  /**
   * User property is a set of properties that will be reported from all events because it relates to the USER not the ACTION.
   *  Since the notification setting only relates to user, it should be reported from user properties
   *
   *  Values:
   *  1 (on)
   *  0 (off)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  notification_settings?: number;
  /**
   * The plan of the user. Warning business isn't fully correct.
   */
  plan?: any;
  referrer?: any;
  role?: any;
  /**
   * whether the consent column
   */
  scribe_call_consent?: boolean;
  userId?: any;
  utm_source?: string;
  /**
   * This will tell you the origination client's environment being evaluated in a backend API feature flag. Based on the X-Blinq-Version header.
   */
  via_api_client_env?: string;
  /**
   * This will tell you the type/name of the requesting client being evaluated in a backend feature flag. Via the X-Blinq-Version header.
   */
  via_api_client_name?: string;
  /**
   * This will tell you the version of the requesting client being evaluated in a backend feature flag. Via the X-Blinq-Version header.
   */
  via_api_client_version?: string;
  /**
   * This tells you the upstream backend event that is triggering an event/evaluation
   */
  via_api_event_subscription?: string;
  /**
   * This tells you the upstream backend event that is triggering an event/evaluation
   */
  via_api_event_topic?: string;
  /**
   * IDs of the user's workspaces.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  workspaces?: string[];
}

export interface AddCreditsViewedProperties {
  /**
   * What the modal offered once the credit summary loaded. form: the preset picker. pending: an earlier request is still awaiting ops, so no picker. unavailable: the summary could not be read.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | form, pending, unavailable |
   */
  modal_state: "form" | "pending" | "unavailable";
  /**
   * Always add_credits for this event.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | native_share_sheet_modal, add_team_member, average_contract_value, share_note_method_selector, ai_notetaker_summary_auto_save_to_contact, campaign, scribe_title_edit, scribe_summary_unsaved_prompt, contact_enrich_add_company, contact_enrich_add_name, contact_enrich_add_multiple, none, contact_enrich_education, scribe_consent, scribe_activation_info, scribe_add_contact, checklist, scribe_share_consent, export_destinations, weekly_upsell, add_credits |
   */
  ref_modal:
    | "native_share_sheet_modal"
    | "add_team_member"
    | "average_contract_value"
    | "share_note_method_selector"
    | "ai_notetaker_summary_auto_save_to_contact"
    | "campaign"
    | "scribe_title_edit"
    | "scribe_summary_unsaved_prompt"
    | "contact_enrich_add_company"
    | "contact_enrich_add_name"
    | "contact_enrich_add_multiple"
    | "none"
    | "contact_enrich_education"
    | "scribe_consent"
    | "scribe_activation_info"
    | "scribe_add_contact"
    | "checklist"
    | "scribe_share_consent"
    | "export_destinations"
    | "weekly_upsell"
    | "add_credits";
  /**
   * Always dash for this event.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | app, app_clip, card_worker, dash, desktop, mobile, apple_watch, android_watch, backend, notification_service, auth_service |
   */
  surface:
    | "app"
    | "app_clip"
    | "card_worker"
    | "dash"
    | "desktop"
    | "mobile"
    | "apple_watch"
    | "android_watch"
    | "backend"
    | "notification_service"
    | "auth_service";
  /**
   * The workspace the credits are for.
   */
  workspace_id: string;
}

export interface BookDemoClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  area?: string;
  name?: any;
  path?: any;
  /**
   * The part of the Blinq product the event triggers in. This is defined
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and platform.
   *
   * Platform: ios
   *
   * * platform: app — Main iOS app
   *
   * * platform: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * platform: app — Main Android app
   *
   * * Platform: web
   *
   *   * platform: card_worker — Web shareflow experience
   *
   *   * platform: dash — Business dashboard
   *
   *   * platform: desktop — General (marketing) web page
   *
   *   * platform: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * platform: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * platform: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * platform: backend — General backend event (e.g. contact_created)
   *
   *   * platform: notification_service — Notification services
   *
   *   * platform: auth_service — Authentication services
   */
  platform?: any;
  /**
   * The modal that appears on the screen when the event was triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | native_share_sheet_modal, add_team_member, average_contract_value, share_note_method_selector, ai_notetaker_summary_auto_save_to_contact, campaign, scribe_title_edit, scribe_summary_unsaved_prompt, contact_enrich_add_company, contact_enrich_add_name, contact_enrich_add_multiple, none, contact_enrich_education, scribe_consent, scribe_activation_info, scribe_add_contact, list_enrichment_paywall |
   */
  ref_modal:
    | "native_share_sheet_modal"
    | "add_team_member"
    | "average_contract_value"
    | "share_note_method_selector"
    | "ai_notetaker_summary_auto_save_to_contact"
    | "campaign"
    | "scribe_title_edit"
    | "scribe_summary_unsaved_prompt"
    | "contact_enrich_add_company"
    | "contact_enrich_add_name"
    | "contact_enrich_add_multiple"
    | "none"
    | "contact_enrich_education"
    | "scribe_consent"
    | "scribe_activation_info"
    | "scribe_add_contact"
    | "list_enrichment_paywall";
  /**
   * This is the page where an event occurs. This is a mandatory field for all events so that we know where they are triggered from.
   */
  ref_page: string;
}

export interface CardDetailUpdatedProperties {
  /**
   * The name of the card field that was updated — e.g. email phone title company.
   */
  card_field: string;
  /**
   * The ID of the card being updated.
   */
  card_id: string;
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the user is on when the update is saved.
   */
  ref_page: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   */
  workspace_id: string;
}

export interface CardFieldDeletedProperties {
  /**
   * The name of the card field that was deleted — e.g. email phone title company.
   */
  card_field: string;
  /**
   * The ID of the card from which the field was deleted.
   */
  card_id: string;
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the user is on when the field is deleted.
   */
  ref_page: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   */
  workspace_id: string;
}

export interface CardSharedProperties {
  card_id?: any;
  card_org_id?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  card_share_method?: string;
  card_update_id?: any;
  /**
   * The ID of user who owns the card in view.
   */
  card_user_id?: string;
  font_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  has_font?: number;
  is_reciprocal_share?: boolean;
  message_id?: string;
  name?: any;
  /**
   * open_source is a property that generally indicates how an event was fired in the app. This could be the UI element that was clicked (push_allow_clicked) or the origin page where an event was done to cause the event to occur (Viewed Card_sharecard).
   *
   * Overall you will need context and testing to determine the exact meaning of this property per event. In some cases it can also indicate the origin of why a back end event is occurring e.g. push notifications of scribe summaries being ready and the setting being enabled to send push notifications.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  open_source?: string;
  /**
   * The part of the Blinq product the event triggers in. This is defined
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and platform.
   *
   * Platform: ios
   *
   * * platform: app — Main iOS app
   *
   * * platform: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * platform: app — Main Android app
   *
   * * Platform: web
   *
   *   * platform: card_worker — Web shareflow experience
   *
   *   * platform: dash — Business dashboard
   *
   *   * platform: desktop — General (marketing) web page
   *
   *   * platform: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * platform: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * platform: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * platform: backend — General backend event (e.g. contact_created)
   *
   *   * platform: notification_service — Notification services
   *
   *   * platform: auth_service — Authentication services
   */
  platform?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  reciprocal_card_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  reciprocal_user_id?: string;
  /**
   * The modal that appears on the screen when the event was triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | native_share_sheet_modal, add_team_member, average_contract_value, share_note_method_selector, ai_notetaker_summary_auto_save_to_contact, campaign, scribe_title_edit, scribe_summary_unsaved_prompt, contact_enrich_add_company, contact_enrich_add_name, contact_enrich_add_multiple, none, contact_enrich_education, scribe_consent, scribe_activation_info, scribe_add_contact, checklist, scribe_share_consent, export_destinations, weekly_upsell |
   */
  ref_modal:
    | "native_share_sheet_modal"
    | "add_team_member"
    | "average_contract_value"
    | "share_note_method_selector"
    | "ai_notetaker_summary_auto_save_to_contact"
    | "campaign"
    | "scribe_title_edit"
    | "scribe_summary_unsaved_prompt"
    | "contact_enrich_add_company"
    | "contact_enrich_add_name"
    | "contact_enrich_add_multiple"
    | "none"
    | "contact_enrich_education"
    | "scribe_consent"
    | "scribe_activation_info"
    | "scribe_add_contact"
    | "checklist"
    | "scribe_share_consent"
    | "export_destinations"
    | "weekly_upsell";
  /**
   * The page the user is on when the event fires — e.g. home or member_details.
   */
  ref_page: string;
  user_id?: any;
  version?: any;
}

export interface CardUpdateDiscardedProperties {
  /**
   * The ID of the card whose changes were discarded.
   */
  card_id: string;
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the user is on when changes are discarded.
   */
  ref_page: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   */
  workspace_id: string;
}

export interface ChangelayoutClickedProperties {
  card_id?: any;
  /**
   * The ID of user who owns the card in view.
   */
  card_user_id?: any;
  message_id?: any;
  module?: any;
  name?: any;
  platform?: any;
  /**
   * The page the user is on when the event fires — e.g. home or member_details.
   */
  ref_page: string;
  user_id?: any;
  version?: any;
}

export interface ContinueClickedProperties {
  card_id?: any;
  /**
   * The ID of user who owns the card in view.
   */
  card_user_id?: string;
  /**
   * Informing whether colour is changed in the onboarding theme selection page
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  colour_changed: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  domain?: string;
  email?: any;
  enrichment_result?: string;
  has_company_name: boolean;
  has_company_url?: boolean;
  has_job_title: boolean;
  has_linkedin?: boolean;
  /**
   * Informing whether card layout is changed in the onboarding theme selection page.
   */
  layout_changed: boolean;
  /**
   * The part of the Blinq product the event triggers in. This is defined
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and platform.
   *
   * Platform: ios
   *
   * * platform: app — Main iOS app
   *
   * * platform: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * platform: app — Main Android app
   *
   * * Platform: web
   *
   *   * platform: card_worker — Web shareflow experience
   *
   *   * platform: dash — Business dashboard
   *
   *   * platform: desktop — General (marketing) web page
   *
   *   * platform: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * platform: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * platform: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * platform: backend — General backend event (e.g. contact_created)
   *
   *   * platform: notification_service — Notification services
   *
   *   * platform: auth_service — Authentication services
   */
  platform?: any;
  /**
   * This is the page where an event occurs. This is a mandatory field for all events so that we know where they are triggered from.
   */
  ref_page: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  request_id?: string;
  /**
   * Where the event happened, e.g. mobile / desktop.
   */
  surface?: string;
  /**
   * **Legacy property**
   *
   * This is a catchall property that denotes the 'type' of event. Needs to be determined from the context in which the event was fired and the circumstances it can be fired in.
   *
   *  Note: This property should no longer be used in any eventing going forward. It is considered almost unusuable/uninterpretable.
   */
  type?: any;
  variant?: any;
}

export interface CreditPackSelectedProperties {
  /**
   * Credit pack size: 250, 500 or 1000.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  credits: number;
  /**
   * The modal that appears on the screen when the event was triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | native_share_sheet_modal, add_team_member, average_contract_value, share_note_method_selector, ai_notetaker_summary_auto_save_to_contact, campaign, scribe_title_edit, scribe_summary_unsaved_prompt, contact_enrich_add_company, contact_enrich_add_name, contact_enrich_add_multiple, none, contact_enrich_education, scribe_consent, scribe_activation_info, scribe_add_contact, checklist, scribe_share_consent, export_destinations, weekly_upsell, add_credits |
   */
  ref_modal:
    | "native_share_sheet_modal"
    | "add_team_member"
    | "average_contract_value"
    | "share_note_method_selector"
    | "ai_notetaker_summary_auto_save_to_contact"
    | "campaign"
    | "scribe_title_edit"
    | "scribe_summary_unsaved_prompt"
    | "contact_enrich_add_company"
    | "contact_enrich_add_name"
    | "contact_enrich_add_multiple"
    | "none"
    | "contact_enrich_education"
    | "scribe_consent"
    | "scribe_activation_info"
    | "scribe_add_contact"
    | "checklist"
    | "scribe_share_consent"
    | "export_destinations"
    | "weekly_upsell"
    | "add_credits";
  /**
   * The part of the Blinq product the event triggers in. This is defined in this document as at Feb 2026: https://www.notion.so/blinq-me/Product-Analytics-Events-Conventions-2a069a35ad8f8066bab4da05f8d36bbc?source=copy_link
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and surface.
   *
   * Platform: ios
   *
   * * Surface: app — Main iOS app
   *
   * * Surface: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * Surface: app — Main Android app
   *
   * * Platform: web
   *
   *   * Surface: card_worker — Web shareflow experience
   *
   *   * Surface: dash — Business dashboard
   *
   *   * Surface: desktop — General (marketing) web page
   *
   *   * Surface: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * Surface: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * Surface: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * Surface: backend — General backend event (e.g. contact_created)
   *
   *   * Surface: notification_service — Notification services
   *
   *   * Surface: auth_service — Authentication services
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | app, app_clip, card_worker, dash, desktop, mobile, apple_watch, android_watch, backend, notification_service, auth_service |
   */
  surface:
    | "app"
    | "app_clip"
    | "card_worker"
    | "dash"
    | "desktop"
    | "mobile"
    | "apple_watch"
    | "android_watch"
    | "backend"
    | "notification_service"
    | "auth_service";
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   */
  workspace_id: string;
}

export interface CustomFontToggledProperties {
  /**
   * The ID of the card whose font setting was toggled.
   */
  card_id: string;
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the user is on when the toggle is changed.
   */
  ref_page: string;
  /**
   * The new state of the custom font toggle — true means enabled false means disabled.
   */
  toggle_state: boolean;
  /**
   * The Blinq user ID of the authenticated user.
   */
  user_id: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   */
  workspace_id: string;
}

export interface DeleteCardClickedProperties {
  /**
   * The part of the Blinq product the event triggers in. This is defined
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and platform.
   *
   * Platform: ios
   *
   * * platform: app — Main iOS app
   *
   * * platform: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * platform: app — Main Android app
   *
   * * Platform: web
   *
   *   * platform: card_worker — Web shareflow experience
   *
   *   * platform: dash — Business dashboard
   *
   *   * platform: desktop — General (marketing) web page
   *
   *   * platform: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * platform: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * platform: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * platform: backend — General backend event (e.g. contact_created)
   *
   *   * platform: notification_service — Notification services
   *
   *   * platform: auth_service — Authentication services
   */
  platform?: any;
  /**
   * The modal that appears on the screen when the event was triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | native_share_sheet_modal, add_team_member, average_contract_value, share_note_method_selector, ai_notetaker_summary_auto_save_to_contact, campaign, scribe_title_edit, scribe_summary_unsaved_prompt, contact_enrich_add_company, contact_enrich_add_name, contact_enrich_add_multiple, none, contact_enrich_education, scribe_consent, scribe_activation_info, scribe_add_contact, checklist, scribe_share_consent, export_destinations, weekly_upsell |
   */
  ref_modal:
    | "native_share_sheet_modal"
    | "add_team_member"
    | "average_contract_value"
    | "share_note_method_selector"
    | "ai_notetaker_summary_auto_save_to_contact"
    | "campaign"
    | "scribe_title_edit"
    | "scribe_summary_unsaved_prompt"
    | "contact_enrich_add_company"
    | "contact_enrich_add_name"
    | "contact_enrich_add_multiple"
    | "none"
    | "contact_enrich_education"
    | "scribe_consent"
    | "scribe_activation_info"
    | "scribe_add_contact"
    | "checklist"
    | "scribe_share_consent"
    | "export_destinations"
    | "weekly_upsell";
  /**
   * This is the page where an event occurs. This is a mandatory field for all events so that we know where they are triggered from.
   */
  ref_page: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  workspace_id: string;
}

export interface EmailsignatureCopiedProperties {
  /**
   * Identifier of email signature in postgres table EmailSignature.
   */
  email_signature_id: string;
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The modal the user is in when the copy action occurs — e.g. card_share_modal.
   */
  ref_modal: string;
  /**
   * The page the user is on when the copy action occurs.
   */
  ref_page: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   */
  workspace_id: string;
}

export interface FontUploadedProperties {
  font_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  font_upload_type?: string;
  /**
   * open_source is a property that generally indicates how an event was fired in the app. This could be the UI element that was clicked (push_allow_clicked) or the origin page where an event was done to cause the event to occur (Viewed Card_sharecard).
   *
   * Overall you will need context and testing to determine the exact meaning of this property per event. In some cases it can also indicate the origin of why a back end event is occurring e.g. push notifications of scribe summaries being ready and the setting being enabled to send push notifications.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  open_source?: string;
  /**
   * The part of the Blinq product the event triggers in. This is defined
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and platform.
   *
   * Platform: ios
   *
   * * platform: app — Main iOS app
   *
   * * platform: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * platform: app — Main Android app
   *
   * * Platform: web
   *
   *   * platform: card_worker — Web shareflow experience
   *
   *   * platform: dash — Business dashboard
   *
   *   * platform: desktop — General (marketing) web page
   *
   *   * platform: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * platform: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * platform: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * platform: backend — General backend event (e.g. contact_created)
   *
   *   * platform: notification_service — Notification services
   *
   *   * platform: auth_service — Authentication services
   */
  platform?: any;
  /**
   * The modal that appears on the screen when the event was triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | native_share_sheet_modal, add_team_member, average_contract_value, share_note_method_selector, ai_notetaker_summary_auto_save_to_contact, campaign, scribe_title_edit, scribe_summary_unsaved_prompt, contact_enrich_add_company, contact_enrich_add_name, contact_enrich_add_multiple, none, contact_enrich_education, scribe_consent, scribe_activation_info, scribe_add_contact, checklist, scribe_share_consent, export_destinations, weekly_upsell |
   */
  ref_modal:
    | "native_share_sheet_modal"
    | "add_team_member"
    | "average_contract_value"
    | "share_note_method_selector"
    | "ai_notetaker_summary_auto_save_to_contact"
    | "campaign"
    | "scribe_title_edit"
    | "scribe_summary_unsaved_prompt"
    | "contact_enrich_add_company"
    | "contact_enrich_add_name"
    | "contact_enrich_add_multiple"
    | "none"
    | "contact_enrich_education"
    | "scribe_consent"
    | "scribe_activation_info"
    | "scribe_add_contact"
    | "checklist"
    | "scribe_share_consent"
    | "export_destinations"
    | "weekly_upsell";
  /**
   * This is the page where an event occurs. This is a mandatory field for all events so that we know where they are triggered from.
   */
  ref_page: string;
  version?: any;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  workspace_id: string;
}

export interface HomeCreateCardClickProperties {
  message_id?: string;
  name?: any;
  /**
   * The part of the Blinq product the event triggers in. This is defined
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and platform.
   *
   * Platform: ios
   *
   * * platform: app — Main iOS app
   *
   * * platform: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * platform: app — Main Android app
   *
   * * Platform: web
   *
   *   * platform: card_worker — Web shareflow experience
   *
   *   * platform: dash — Business dashboard
   *
   *   * platform: desktop — General (marketing) web page
   *
   *   * platform: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * platform: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * platform: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * platform: backend — General backend event (e.g. contact_created)
   *
   *   * platform: notification_service — Notification services
   *
   *   * platform: auth_service — Authentication services
   */
  platform?: any;
  /**
   * The modal that appears on the screen when the event was triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | native_share_sheet_modal, add_team_member, average_contract_value, share_note_method_selector, ai_notetaker_summary_auto_save_to_contact, campaign, scribe_title_edit, scribe_summary_unsaved_prompt, contact_enrich_add_company, contact_enrich_add_name, contact_enrich_add_multiple, none, contact_enrich_education, scribe_consent, scribe_activation_info, scribe_add_contact, checklist, scribe_share_consent, export_destinations, weekly_upsell |
   */
  ref_modal:
    | "native_share_sheet_modal"
    | "add_team_member"
    | "average_contract_value"
    | "share_note_method_selector"
    | "ai_notetaker_summary_auto_save_to_contact"
    | "campaign"
    | "scribe_title_edit"
    | "scribe_summary_unsaved_prompt"
    | "contact_enrich_add_company"
    | "contact_enrich_add_name"
    | "contact_enrich_add_multiple"
    | "none"
    | "contact_enrich_education"
    | "scribe_consent"
    | "scribe_activation_info"
    | "scribe_add_contact"
    | "checklist"
    | "scribe_share_consent"
    | "export_destinations"
    | "weekly_upsell";
  /**
   * This is the page where an event occurs. This is a mandatory field for all events so that we know where they are triggered from.
   */
  ref_page: string;
  user_id?: any;
}

export interface HomeEditCardClickProperties {
  card_id?: any;
  message_id?: any;
  name?: any;
  platform?: any;
  ref_page?: string;
  user_id?: any;
}

export interface IdentitySelectorClickedProperties {
  /**
   * The ID of the card currently selected when the identity selector was clicked.
   */
  card_id?: string;
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the user is on when the identity selector is clicked — e.g. home or member_details.
   */
  ref_page: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   */
  workspace_id: string;
}

export interface IdentitySelectorSelectedProperties {
  /**
   * The ID of the card currently selected when the identity selector was clicked.
   */
  card_id?: string;
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The modal that appears on the screen when the event was triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | native_share_sheet_modal, add_team_member, average_contract_value, share_note_method_selector, ai_notetaker_summary_auto_save_to_contact, campaign, scribe_title_edit, scribe_summary_unsaved_prompt, contact_enrich_add_company, contact_enrich_add_name, contact_enrich_add_multiple, none, contact_enrich_education, scribe_consent, scribe_activation_info, scribe_add_contact, checklist, scribe_share_consent, export_destinations, weekly_upsell |
   */
  ref_modal:
    | "native_share_sheet_modal"
    | "add_team_member"
    | "average_contract_value"
    | "share_note_method_selector"
    | "ai_notetaker_summary_auto_save_to_contact"
    | "campaign"
    | "scribe_title_edit"
    | "scribe_summary_unsaved_prompt"
    | "contact_enrich_add_company"
    | "contact_enrich_add_name"
    | "contact_enrich_add_multiple"
    | "none"
    | "contact_enrich_education"
    | "scribe_consent"
    | "scribe_activation_info"
    | "scribe_add_contact"
    | "checklist"
    | "scribe_share_consent"
    | "export_destinations"
    | "weekly_upsell";
  /**
   * The page the user is on when the identity selector is clicked — e.g. home or member_details.
   */
  ref_page: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   */
  workspace_id: string;
}

export interface ListEnrichmentFileRejectedProperties {
  /**
   * Size of the rejected file in kilobytes. Absent when the rejection carries no file.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  file_size_kb?: number;
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the user is on when the event fires. Always list_enrichment_new.
   */
  ref_page: string;
  /**
   * Why the file was rejected. The first three come from the dropzone before parse; the last three from the CSV parser.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | file-invalid-type, file-too-large, too-many-files, no-contents, duplicated-headers, parse-failed |
   */
  reject_reason:
    | "file-invalid-type"
    | "file-too-large"
    | "too-many-files"
    | "no-contents"
    | "duplicated-headers"
    | "parse-failed";
  /**
   * The workspace the user was operating in when they fired the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  workspace_id: string;
}

export interface ListEnrichmentFileUploadedProperties {
  /**
   * Number of columns detected in the uploaded CSV header.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  column_count: number;
  /**
   * Size of the uploaded file in kilobytes rounded to the nearest integer.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  file_size_kb: number;
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the user is on when the event fires. Always list_enrichment_new.
   */
  ref_page: string;
  /**
   * Number of data rows in the uploaded CSV excluding the header.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  row_count: number;
  /**
   * The workspace the user was operating in when they fired the event.
   */
  workspace_id: string;
}

export interface ListEnrichmentListViewedProperties {
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the user is on when the event fires. Always list_enrichment_list.
   */
  ref_page: string;
  /**
   * The workspace the user was viewing the page in.
   */
  workspace_id: string;
}

export interface ListEnrichmentNewViewedProperties {
  /**
   * The part of the Blinq product the event triggers in. This is defined
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and platform.
   *
   * Platform: ios
   *
   * * platform: app — Main iOS app
   *
   * * platform: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * platform: app — Main Android app
   *
   * * Platform: web
   *
   *   * platform: card_worker — Web shareflow experience
   *
   *   * platform: dash — Business dashboard
   *
   *   * platform: desktop — General (marketing) web page
   *
   *   * platform: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * platform: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * platform: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * platform: backend — General backend event (e.g. contact_created)
   *
   *   * platform: notification_service — Notification services
   *
   *   * platform: auth_service — Authentication services
   */
  platform?: string;
  /**
   * The page the user is on when the event fires. Always list_enrichment_new.
   */
  ref_page: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   */
  workspace_id: string;
}

export interface ListEnrichmentPaywallViewedProperties {
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the paywall was shown on: list_enrichment_list or list_enrichment_new.
   */
  ref_page: string;
  /**
   * The workspace whose plan does not include bulk enrichment.
   */
  workspace_id: string;
}

export interface ListEnrichmentResultsExportedProperties {
  /**
   * Number of rows written to the exported CSV.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  exported_row_count: number;
  /**
   * True when the user exported a subset of rows rather than the whole job.
   */
  is_row_selection: boolean;
  /**
   * The list enrichment job whose results were exported.
   */
  job_id: string;
  /**
   * Total rows in the job. Equals exported_row_count unless the user selected a subset.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  job_row_count: number;
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the user is on when the event fires. Always list_enrichment_job.
   */
  ref_page: string;
  /**
   * The workspace the user was operating in when they fired the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  workspace_id: string;
}

export interface MenuUpgradeClickedProperties {
  /**
   * The ID of user who owns the card in view.
   */
  card_user_id?: any;
  message_id?: any;
  name?: any;
  platform?: any;
  /**
   * The page the user is on when the event fires — e.g. home or member_details.
   */
  ref_page: string;
  subscription_plan?: any;
  user_id?: any;
}

export interface OnboardingAlreadyHaveAppClickedProperties {
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The page the user is on when the event fires. Always home.
   */
  ref_page: string;
  /**
   * The Blinq user ID of the authenticated user who clicked the CTA.
   */
  user_id: string;
  /**
   * The ID of the workspace the user is operating in.
   */
  workspace_id?: string;
}

export interface OnboardingGetAppButtonClickedProperties {
  /**
   * The platform the event was fired from. Always dash.
   */
  platform: string;
  /**
   * The modal the user is in when the button is clicked — e.g. card_share_modal.
   */
  ref_modal?: string;
  /**
   * The page the user is on when the button is clicked — e.g. home.
   */
  ref_page: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   */
  workspace_id: string;
}

export interface PlanSelectViewedProperties {
  /**
   * The discount shown or applied, as a percentage. Only sent when a discount is offered.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  discount_percentage?: number;
  /**
   * What opened the plan selection screen, e.g. referral_landing / web_onboarding.
   */
  open_source?: string;
  /**
   * The page the event was fired from.
   */
  ref_page?: string;
  /**
   * Where the event happened, e.g. mobile / desktop.
   */
  surface?: string;
}

export interface PlanSelectedProperties {
  /**
   * The discount shown or applied, as a percentage. Only sent when a discount is offered.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  discount_percentage?: number;
  /**
   * The selected plan: free / premium / pro.
   */
  plan?: string;
  /**
   * The page the event was fired from.
   */
  ref_page?: string;
  /**
   * Where the event happened, e.g. mobile / desktop.
   */
  surface?: string;
  /**
   * The selected billing term: monthly / annual.
   */
  term?: string;
}

export interface QrcodeDownloadedProperties {
  page?: any;
  platform?: any;
  /**
   * The page the user is on when the event fires — e.g. home or member_details.
   */
  ref_page: string;
  version?: any;
}

export interface ReferralProgramLandingViewedProperties {
  /**
   * The page the event was fired from.
   */
  ref_page?: string;
  /**
   * The referral program code carried by the event, e.g. a Cello referral code.
   */
  referral_code?: string;
  /**
   * Where the event happened, e.g. mobile / desktop.
   */
  surface?: string;
}

export interface SharecardbuttonClickedProperties {
  card_id?: string;
  card_org_id?: string;
  card_update_id?: string;
  card_user_id?: string;
  font_id?: string;
  has_font?: string;
  message_id?: string;
  name?: any;
  /**
   * The part of the Blinq product the event triggers in. This is defined
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and platform.
   *
   * Platform: ios
   *
   * * platform: app — Main iOS app
   *
   * * platform: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * platform: app — Main Android app
   *
   * * Platform: web
   *
   *   * platform: card_worker — Web shareflow experience
   *
   *   * platform: dash — Business dashboard
   *
   *   * platform: desktop — General (marketing) web page
   *
   *   * platform: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * platform: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * platform: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * platform: backend — General backend event (e.g. contact_created)
   *
   *   * platform: notification_service — Notification services
   *
   *   * platform: auth_service — Authentication services
   */
  platform?: any;
  /**
   * The page the user is on when the event fires — e.g. home or member_details.
   */
  ref_page: string;
  version?: any;
}

export interface Start30DaytrialClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Domain"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Path"?: string;
  /**
   * Captures the page title of the page where the element was clicked.
   *
   * For example, if the page where the element was clicked has: <title>Amplitude</title>
   *
   * The value would be: Amplitude
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page Title"?: string;
  /**
   * Captures the URL of the page where the element was clicked.
   *
   * For example, a value of https://www.amplitude.com means that the element clicked was on this page.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Page URL"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Location"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Previous Page Type"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  area?: string;
  name?: any;
  path?: any;
  /**
   * The part of the Blinq product the event triggers in. This is defined
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and platform.
   *
   * Platform: ios
   *
   * * platform: app — Main iOS app
   *
   * * platform: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * platform: app — Main Android app
   *
   * * Platform: web
   *
   *   * platform: card_worker — Web shareflow experience
   *
   *   * platform: dash — Business dashboard
   *
   *   * platform: desktop — General (marketing) web page
   *
   *   * platform: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * platform: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * platform: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * platform: backend — General backend event (e.g. contact_created)
   *
   *   * platform: notification_service — Notification services
   *
   *   * platform: auth_service — Authentication services
   */
  platform?: any;
}

export interface ViewedPageViewProperties {
  name?: any;
  path?: any;
  properties?: {
    path?: {
      [k: string]: any;
    };
  };
  /**
   * This is the page where an event occurs. This is a mandatory field for all events so that we know where they are triggered from.
   */
  ref_page: string;
  referrer?: any;
  search?: any;
  title?: any;
  url?: any;
}

export interface VirtualbackgroundDownloadClickedProperties {
  /**
   * The part of the Blinq product the event triggers in. This is defined
   *
   * Platform (managed by amplitude) is used in the description below to show the difference between Platform and platform.
   *
   * Platform: ios
   *
   * * platform: app — Main iOS app
   *
   * * platform: app_clip — App Clip experience
   *
   * * Platform: android
   *
   *   * platform: app — Main Android app
   *
   * * Platform: web
   *
   *   * platform: card_worker — Web shareflow experience
   *
   *   * platform: dash — Business dashboard
   *
   *   * platform: desktop — General (marketing) web page
   *
   *   * platform: mobile — Mobile browser experience
   *
   * * Platform: watchos
   *
   *   * platform: apple_watch — Apple Watch experience
   *
   * * Platform: wearos
   *
   *   * platform: android_watch — Android smartwatch experience
   *
   * * Platform: server
   *
   *   * platform: backend — General backend event (e.g. contact_created)
   *
   *   * platform: notification_service — Notification services
   *
   *   * platform: auth_service — Authentication services
   */
  platform?: any;
  /**
   * The modal that appears on the screen when the event was triggered
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | native_share_sheet_modal, add_team_member, average_contract_value, share_note_method_selector, ai_notetaker_summary_auto_save_to_contact, campaign, scribe_title_edit, scribe_summary_unsaved_prompt, contact_enrich_add_company, contact_enrich_add_name, contact_enrich_add_multiple, none, contact_enrich_education, scribe_consent, scribe_activation_info, scribe_add_contact, checklist, scribe_share_consent, export_destinations, weekly_upsell |
   */
  ref_modal:
    | "native_share_sheet_modal"
    | "add_team_member"
    | "average_contract_value"
    | "share_note_method_selector"
    | "ai_notetaker_summary_auto_save_to_contact"
    | "campaign"
    | "scribe_title_edit"
    | "scribe_summary_unsaved_prompt"
    | "contact_enrich_add_company"
    | "contact_enrich_add_name"
    | "contact_enrich_add_multiple"
    | "none"
    | "contact_enrich_education"
    | "scribe_consent"
    | "scribe_activation_info"
    | "scribe_add_contact"
    | "checklist"
    | "scribe_share_consent"
    | "export_destinations"
    | "weekly_upsell";
  /**
   * This is the page where an event occurs. This is a mandatory field for all events so that we know where they are triggered from.
   */
  ref_page: string;
  /**
   * Identifier of virtual background signature in firestore table: virtual_background
   */
  virtual_background_id: string;
  /**
   * The workspaceid the user was operating in when they fired the event.
   *
   *  This may be a problematic even in how it is implemented in app as it hasn't been checked whether it will take the highest permission workspace the user has at that time i.e. if a user is part of a business account and has a free account as well, whenever they are using the app we should expect to see the business workspace_id
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  workspace_id: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AddCreditsViewed implements BaseEvent {
  event_type = 'add_credits_viewed';

  constructor(
    public event_properties: AddCreditsViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BookDemoClicked implements BaseEvent {
  event_type = 'book_demo_clicked';

  constructor(
    public event_properties: BookDemoClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CardDetailUpdated implements BaseEvent {
  event_type = 'card_detail_updated';

  constructor(
    public event_properties: CardDetailUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CardFieldDeleted implements BaseEvent {
  event_type = 'card_field_deleted';

  constructor(
    public event_properties: CardFieldDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CardShared implements BaseEvent {
  event_type = 'card_shared';

  constructor(
    public event_properties: CardSharedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CardUpdateDiscarded implements BaseEvent {
  event_type = 'card_update_discarded';

  constructor(
    public event_properties: CardUpdateDiscardedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChangelayoutClicked implements BaseEvent {
  event_type = 'changelayout_clicked';

  constructor(
    public event_properties: ChangelayoutClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContinueClicked implements BaseEvent {
  event_type = 'continue_clicked';

  constructor(
    public event_properties: ContinueClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CreditPackSelected implements BaseEvent {
  event_type = 'credit_pack_selected';

  constructor(
    public event_properties: CreditPackSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CustomFontToggled implements BaseEvent {
  event_type = 'custom_font_toggled';

  constructor(
    public event_properties: CustomFontToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DeleteCardClicked implements BaseEvent {
  event_type = 'delete_card_clicked';

  constructor(
    public event_properties: DeleteCardClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailsignatureCopied implements BaseEvent {
  event_type = 'emailsignature_copied';

  constructor(
    public event_properties: EmailsignatureCopiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FontUploaded implements BaseEvent {
  event_type = 'font_uploaded';

  constructor(
    public event_properties: FontUploadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HomeCreateCardClick implements BaseEvent {
  event_type = 'home_create_card_click';

  constructor(
    public event_properties: HomeCreateCardClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HomeEditCardClick implements BaseEvent {
  event_type = 'home_edit_card_click';

  constructor(
    public event_properties?: HomeEditCardClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class IdentitySelectorClicked implements BaseEvent {
  event_type = 'identity_selector_clicked';

  constructor(
    public event_properties: IdentitySelectorClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class IdentitySelectorSelected implements BaseEvent {
  event_type = 'identity_selector_selected';

  constructor(
    public event_properties: IdentitySelectorSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListEnrichmentFileRejected implements BaseEvent {
  event_type = 'list_enrichment_file_rejected';

  constructor(
    public event_properties: ListEnrichmentFileRejectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListEnrichmentFileUploaded implements BaseEvent {
  event_type = 'list_enrichment_file_uploaded';

  constructor(
    public event_properties: ListEnrichmentFileUploadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListEnrichmentListViewed implements BaseEvent {
  event_type = 'list_enrichment_list_viewed';

  constructor(
    public event_properties: ListEnrichmentListViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListEnrichmentNewViewed implements BaseEvent {
  event_type = 'list_enrichment_new_viewed';

  constructor(
    public event_properties: ListEnrichmentNewViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListEnrichmentPaywallViewed implements BaseEvent {
  event_type = 'list_enrichment_paywall_viewed';

  constructor(
    public event_properties: ListEnrichmentPaywallViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListEnrichmentResultsExported implements BaseEvent {
  event_type = 'list_enrichment_results_exported';

  constructor(
    public event_properties: ListEnrichmentResultsExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MenuUpgradeClicked implements BaseEvent {
  event_type = 'menu_upgrade_clicked';

  constructor(
    public event_properties: MenuUpgradeClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OnboardingAlreadyHaveAppClicked implements BaseEvent {
  event_type = 'onboarding_already_have_app_clicked';

  constructor(
    public event_properties: OnboardingAlreadyHaveAppClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OnboardingGetAppButtonClicked implements BaseEvent {
  event_type = 'onboarding_get_app_button_clicked';

  constructor(
    public event_properties: OnboardingGetAppButtonClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PlanSelectViewed implements BaseEvent {
  event_type = 'plan_select_viewed';

  constructor(
    public event_properties?: PlanSelectViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PlanSelected implements BaseEvent {
  event_type = 'plan_selected';

  constructor(
    public event_properties?: PlanSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class QrcodeDownloaded implements BaseEvent {
  event_type = 'qrcode_downloaded';

  constructor(
    public event_properties: QrcodeDownloadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReferralProgramLandingViewed implements BaseEvent {
  event_type = 'referral_program_landing_viewed';

  constructor(
    public event_properties?: ReferralProgramLandingViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SharecardbuttonClicked implements BaseEvent {
  event_type = 'sharecardbutton_clicked';

  constructor(
    public event_properties: SharecardbuttonClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class Start30DaytrialClicked implements BaseEvent {
  event_type = 'start30daytrial_clicked';

  constructor(
    public event_properties?: Start30DaytrialClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewedPageView implements BaseEvent {
  event_type = 'Viewed page_view';

  constructor(
    public event_properties: ViewedPageViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class VirtualbackgroundDownloadClicked implements BaseEvent {
  event_type = 'virtualbackground_download_clicked';

  constructor(
    public event_properties: VirtualbackgroundDownloadClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * add_credits_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/add_credits_viewed)
   *
   * The add-credits modal was opened on the dashboard. Top of the usage-billing credit purchase funnel: add_credits_viewed -> credit_pack_selected -> credits_requested -> credit_request_resolved (result fulfilled).
   *
   * @param properties The event's properties (e.g. modal_state)
   * @param options Amplitude event options.
   */
  addCreditsViewed(
    properties: AddCreditsViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AddCreditsViewed(properties), options);
  }

  /**
   * book_demo_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/book_demo_clicked)
   *
   * This event records when a user clicks a variant of "Book Demo" button within the application or dashboard. It is triggered immediately upon the user's interaction to initiate scheduling a product demonstration. This event helps track user interest in acquiring the business plan or ELC functionality.
   *
   * @param properties The event's properties (e.g. area)
   * @param options Amplitude event options.
   */
  bookDemoClicked(
    properties: BookDemoClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BookDemoClicked(properties), options);
  }

  /**
   * card_detail_updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/card_detail_updated)
   *
   * Fires when a user saves an update to a specific field on their card from the member details view. Provides field-level granularity on top of the backend card_updated event.
   *
   * @param properties The event's properties (e.g. card_field)
   * @param options Amplitude event options.
   */
  cardDetailUpdated(
    properties: CardDetailUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CardDetailUpdated(properties), options);
  }

  /**
   * card_field_deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/card_field_deleted)
   *
   * Fires when a user deletes a field from their card in the unified profile view.
   *
   * @param properties The event's properties (e.g. card_field)
   * @param options Amplitude event options.
   */
  cardFieldDeleted(
    properties: CardFieldDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CardFieldDeleted(properties), options);
  }

  /**
   * card_shared
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/card_shared)
   *
   * When a user shares their card via the share sheet OR contactslist OR Share Card button in dash.
   *
   * **Triggers when:**
   *
   * * A user goes to their contact list → “Shares your card back to this person”
   *
   * * A user clicks send → Shares via “link/sms/email/…..”
   *
   *   * Sometimes this is the action just prior to sharing. For example when doing a Linkedin share, the ‘sharing’ action occurs in Linkedin and we cannot track it. So we take the latest point we can in the sharing funnel and call that a share.
   *
   * * A Blinq users shares back their card to a Blinq user
   *
   * **Doesn’t Trigger when:**
   *
   * * A QR code is scanned
   *
   * [Notion](https://www.notion.so/blinq-me/card_shared-4e77d62d027441dfb844c6390c292c08?source=copy_link)
   *
   * Owner: Briony Gibson
   *
   * @param properties The event's properties (e.g. card_id)
   * @param options Amplitude event options.
   */
  cardShared(
    properties: CardSharedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CardShared(properties), options);
  }

  /**
   * card_update_discarded
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/card_update_discarded)
   *
   * Fires when a user clicks discard and abandons unsaved changes to their card in the unified profile member details view.
   *
   * @param properties The event's properties (e.g. card_id)
   * @param options Amplitude event options.
   */
  cardUpdateDiscarded(
    properties: CardUpdateDiscardedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CardUpdateDiscarded(properties), options);
  }

  /**
   * changelayout_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/changelayout_clicked)
   *
   * A user clicks on a new card layout to change the look of their card.
   *
   * @param properties The event's properties (e.g. card_id)
   * @param options Amplitude event options.
   */
  changelayoutClicked(
    properties: ChangelayoutClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChangelayoutClicked(properties), options);
  }

  /**
   * continue_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/continue_clicked)
   *
   * **WARNING**: This description is updated as we go as part of the mapping to Amplitude project.
   *
   * \------------------------------------
   *
   * Pages triggering this event
   *
   * **OTP**:
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   * **DESIGN CONSIDERATIONS:**
   *
   * * OTP: When clicked in the Sign in with email page, the ref\*page value should be: onboarding__signup
   *
   * * OTP:  ref_page potential values:
   *
   *   * otp_signin
   *
   *   * otp_signup
   *
   *   * otp_failed_viewed
   *
   * Owner: Briony Gibson
   *
   * @param properties The event's properties (e.g. card_id)
   * @param options Amplitude event options.
   */
  continueClicked(
    properties: ContinueClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContinueClicked(properties), options);
  }

  /**
   * credit_pack_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/credit_pack_selected)
   *
   * A preset credit pack was picked in the add-credits modal. Shows which amounts people consider, including those who never submit.
   *
   * @param properties The event's properties (e.g. credits)
   * @param options Amplitude event options.
   */
  creditPackSelected(
    properties: CreditPackSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CreditPackSelected(properties), options);
  }

  /**
   * custom_font_toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/custom_font_toggled)
   *
   * Fires when a user toggles the custom font setting on or off in the card layout view.
   *
   * @param properties The event's properties (e.g. card_id)
   * @param options Amplitude event options.
   */
  customFontToggled(
    properties: CustomFontToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new CustomFontToggled(properties), options);
  }

  /**
   * delete_card_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/delete_card_clicked)
   *
   * This event is triggered when a user clicks the option to delete their card/ dash identity. It captures the user’s intent to initiate the card deletion process.
   *
   * @param properties The event's properties (e.g. platform)
   * @param options Amplitude event options.
   */
  deleteCardClicked(
    properties: DeleteCardClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DeleteCardClicked(properties), options);
  }

  /**
   * emailsignature_copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/emailsignature_copied)
   *
   * Fires when a user copies their email signature from the card share modal on the dashboard.
   *
   * @param properties The event's properties (e.g. email_signature_id)
   * @param options Amplitude event options.
   */
  emailsignatureCopied(
    properties: EmailsignatureCopiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailsignatureCopied(properties), options);
  }

  /**
   * font_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/font_uploaded)
   *
   * When font is successfully uploaded - uploaded for first time only **Event properties:**  
   *  type:
   *
   * * upload
   *
   * * replace
   *
   * open_source:
   *
   * * workspace
   *
   * * card_edit
   *
   * * template
   *
   * workspace_id font_id
   *
   * Owner: Amanda Chan
   *
   * @param properties The event's properties (e.g. font_id)
   * @param options Amplitude event options.
   */
  fontUploaded(
    properties: FontUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FontUploaded(properties), options);
  }

  /**
   * home_create_card_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/home_create_card_click)
   *
   * Fires when a user clicks the Create Card button on the dashboard home screen.
   *
   * @param properties The event's properties (e.g. message_id)
   * @param options Amplitude event options.
   */
  homeCreateCardClick(
    properties: HomeCreateCardClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new HomeCreateCardClick(properties), options);
  }

  /**
   * home_edit_card_click
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/home_edit_card_click)
   *
   * This event captures when a user clicks the edit button on a card from the home screen. It is triggered immediately upon the user initiating an edit action on a card within the Blinq application or dash home interface.
   *
   * @param properties The event's properties (e.g. card_id)
   * @param options Amplitude event options.
   */
  homeEditCardClick(
    properties?: HomeEditCardClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new HomeEditCardClick(properties), options);
  }

  /**
   * identity_selector_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/identity_selector_clicked)
   *
   * Fires when a user clicks the identity selector to switch between cards or profiles in the unified profile view.
   *
   * @param properties The event's properties (e.g. card_id)
   * @param options Amplitude event options.
   */
  identitySelectorClicked(
    properties: IdentitySelectorClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new IdentitySelectorClicked(properties), options);
  }

  /**
   * identity_selector_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/identity_selector_selected)
   *
   * Fires when a user clicks the identity from the selector that they would like to switch to.
   *
   * @param properties The event's properties (e.g. card_id)
   * @param options Amplitude event options.
   */
  identitySelectorSelected(
    properties: IdentitySelectorSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new IdentitySelectorSelected(properties), options);
  }

  /**
   * list_enrichment_file_rejected
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/list_enrichment_file_rejected)
   *
   * A CSV was rejected before or during parse. Funnel loss at the upload step.
   *
   * @param properties The event's properties (e.g. file_size_kb)
   * @param options Amplitude event options.
   */
  listEnrichmentFileRejected(
    properties: ListEnrichmentFileRejectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListEnrichmentFileRejected(properties), options);
  }

  /**
   * list_enrichment_file_uploaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/list_enrichment_file_uploaded)
   *
   * A CSV was accepted and parsed on the bulk enrichment create form. Top of the self-serve funnel.
   *
   * @param properties The event's properties (e.g. column_count)
   * @param options Amplitude event options.
   */
  listEnrichmentFileUploaded(
    properties: ListEnrichmentFileUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListEnrichmentFileUploaded(properties), options);
  }

  /**
   * list_enrichment_list_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/list_enrichment_list_viewed)
   *
   * The bulk enrichment jobs list page was viewed. Page-level denominator: every visitor, whether or not their workspace has access.
   *
   * @param properties The event's properties (e.g. platform)
   * @param options Amplitude event options.
   */
  listEnrichmentListViewed(
    properties: ListEnrichmentListViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListEnrichmentListViewed(properties), options);
  }

  /**
   * list_enrichment_new_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/list_enrichment_new_viewed)
   *
   * The bulk enrichment create page was viewed. Top-of-funnel denominator for the upload step; every visitor, whether or not their workspace has access.
   *
   * @param properties The event's properties (e.g. platform)
   * @param options Amplitude event options.
   */
  listEnrichmentNewViewed(
    properties: ListEnrichmentNewViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListEnrichmentNewViewed(properties), options);
  }

  /**
   * list_enrichment_paywall_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/list_enrichment_paywall_viewed)
   *
   * The bulk enrichment paywall was shown to a workspace without access. Denominator for book_demo_clicked on this surface.
   *
   * @param properties The event's properties (e.g. platform)
   * @param options Amplitude event options.
   */
  listEnrichmentPaywallViewed(
    properties: ListEnrichmentPaywallViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListEnrichmentPaywallViewed(properties), options);
  }

  /**
   * list_enrichment_results_exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/list_enrichment_results_exported)
   *
   * Job results were exported to CSV. Value realisation for a completed job.
   *
   * @param properties The event's properties (e.g. exported_row_count)
   * @param options Amplitude event options.
   */
  listEnrichmentResultsExported(
    properties: ListEnrichmentResultsExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListEnrichmentResultsExported(properties), options);
  }

  /**
   * menu_upgrade_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/menu_upgrade_clicked)
   *
   * User clicks on the "Upgrade Now" button to consider a business or premium plan
   *
   * @param properties The event's properties (e.g. card_user_id)
   * @param options Amplitude event options.
   */
  menuUpgradeClicked(
    properties: MenuUpgradeClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MenuUpgradeClicked(properties), options);
  }

  /**
   * onboarding_already_have_app_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/onboarding_already_have_app_clicked)
   *
   * Fires when a user clicks "I already have the mobile app" on the onboarding banner on the dashboard home screen.
   *
   * @param properties The event's properties (e.g. platform)
   * @param options Amplitude event options.
   */
  onboardingAlreadyHaveAppClicked(
    properties: OnboardingAlreadyHaveAppClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OnboardingAlreadyHaveAppClicked(properties), options);
  }

  /**
   * onboarding_get_app_button_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/onboarding_get_app_button_clicked)
   *
   * Fires when a user clicks the Get the app button shown on the Finish Setup section or Share your profile during dashboard onboarding.
   *
   * @param properties The event's properties (e.g. platform)
   * @param options Amplitude event options.
   */
  onboardingGetAppButtonClicked(
    properties: OnboardingGetAppButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OnboardingGetAppButtonClicked(properties), options);
  }

  /**
   * plan_select_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/plan_select_viewed)
   *
   * The plan selection screen was viewed (referral paywall or web onboarding). New event (ACT-2014; implemented in ACT-2017 web).
   *
   * @param properties The event's properties (e.g. discount_percentage)
   * @param options Amplitude event options.
   */
  planSelectViewed(
    properties?: PlanSelectViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlanSelectViewed(properties), options);
  }

  /**
   * plan_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/plan_selected)
   *
   * The user selected a plan on the plan selection screen. New event (ACT-2014; implemented in ACT-2017 web).
   *
   * @param properties The event's properties (e.g. discount_percentage)
   * @param options Amplitude event options.
   */
  planSelected(
    properties?: PlanSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlanSelected(properties), options);
  }

  /**
   * qrcode_downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/qrcode_downloaded)
   *
   * This event records when a user downloads a QR code. It is triggered immediately after the download action is successfully initiated.
   *
   * @param properties The event's properties (e.g. page)
   * @param options Amplitude event options.
   */
  qrcodeDownloaded(
    properties: QrcodeDownloadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new QrcodeDownloaded(properties), options);
  }

  /**
   * referral_program_landing_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/referral_program_landing_viewed)
   *
   * The Cello referral landing page was viewed by a (potential) referee. New event (ACT-2014; implemented in ACT-2017 web).
   *
   * @param properties The event's properties (e.g. ref_page)
   * @param options Amplitude event options.
   */
  referralProgramLandingViewed(
    properties?: ReferralProgramLandingViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReferralProgramLandingViewed(properties), options);
  }

  /**
   * sharecardbutton_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/sharecardbutton_clicked)
   *
   * This event captures when a user clicks the "Share Card" or "Share your Profile" button within the Blinq app or Dashboard. It is triggered immediately upon the user's interaction with this button to initiate sharing their digital business card.
   *
   * Owner: rian@blinq.me
   *
   * @param properties The event's properties (e.g. card_id)
   * @param options Amplitude event options.
   */
  sharecardbuttonClicked(
    properties: SharecardbuttonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SharecardbuttonClicked(properties), options);
  }

  /**
   * start30daytrial_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/start30daytrial_clicked)
   *
   * When This event captures when a user clicks the button or link to initiate a 30-day free trial within the business onboarding process from the maerketing website.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  start30DaytrialClicked(
    properties?: Start30DaytrialClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new Start30DaytrialClicked(properties), options);
  }

  /**
   * Viewed page_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/Viewed%20page_view)
   *
   * It is triggered by all the web pages in the Web app.
   *
   * The properties provide more information on path, host and sometimes referrer
   *
   * Owner: Victor Fateh
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  viewedPageView(
    properties: ViewedPageViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewedPageView(properties), options);
  }

  /**
   * virtualbackground_download_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/blinq-hq/Blinq/events/main/latest/virtualbackground_download_clicked)
   *
   * This event is triggered when a user clicks the download button for a virtual background . It captures the intent to download a specific virtual background asset.
   *
   * @param properties The event's properties (e.g. platform)
   * @param options Amplitude event options.
   */
  virtualbackgroundDownloadClicked(
    properties: VirtualbackgroundDownloadClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new VirtualbackgroundDownloadClicked(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
